{
  "Accessibility Menu": "תפריט נגישות",
  "Reset settings": "איפוס הגדרות",
  "Close": "סגור",
  "Content Adjustments": "התאמות תוכן",
  "Adjust Font Size": "התאם גודל פונט",
  "Highlight Title": "הדגש כותרת",
  "Highlight Links": "הדגש קישורים",
  "Readable Font": "פונט קריא",
  "Color Adjustments": "התאמות צבע",
  "Dark Contrast": "ניגודיות כהה",
  "Light Contrast": "ניגודיות בהירה",
  "High Contrast": "ניגודיות גבוהה",
  "High Saturation": "רווי צבע גבוה",
  "Low Saturation": "רווי צבע נמוך",
  "Monochrome": "מונוכרום",
  "Contrast": "ניגודיות",
  "Invert Colors": "היפוך צבעים",
  "Tools": "כלים",
  "Reading Guide": "מדריך קריאה",
  "Stop Animations": "עצירת אנימציות",
  "Big Cursor": "סמן גדול",
  "Increase Font Size": "הגדל גודל פונט",
  "Decrease Font Size": "הקטן גודל פונט",
  "Letter Spacing": "מרווח בין אותיות",
  "Line Height": "גובה שורה",
  "Font Weight": "משקל הפונט",
  "Dyslexia Font": "פונט לדיסלקטים",
  "Language": "שפה",
  "Open Accessibility Menu": "פתח תפריט נגישות",
  "Widget Settings": "הגדרות הווידג׳ט",
  "Widget Position": "מיקום הווידג׳ט",
  "Top Left": "למעלה משמאל",
  "Top Center": "למעלה במרכז",
  "Top Right": "למעלה מימין",
  "Center Left": "במרכז משמאל",
  "Center Right": "במרכז מימין",
  "Bottom Left": "למטה משמאל",
  "Bottom Center": "למטה במרכז",
  "Bottom Right": "למטה מימין",
  "Screen Reader": "קורא מסך",
  "Voice Navigation": "ניווט קולי",
  "Custom Color": "צבע מותאם אישית",
  "Change the site's colors": "שנה את צבעי האתר",
  "Backgrounds": "רקעים",
  "Headings": "כותרות",
  "Contents": "תכנים",
  "Reset colors": "איפוס צבעים",
  "Image Desaturation": "הפחתת צבע בתמונה",
  "Search languages": "חפש שפות",
  "No languages found": "לא נמצאו שפות",
  "Accessibility Profiles": "פרופילי נגישות",
  "Motor Impaired": "מוגבלות מוטורית",
  "Big cursor, voice navigation, and no animations.": "סמן גדול, ניווט קולי וללא אנימציות.",
  "Blind": "עיוור",
  "Screen reader helpers with higher contrast.": "מסייעי קורא מסך עם ניגודיות גבוהה יותר.",
  "Color Blind": "עיוורון צבעים",
  "High contrast palette with desaturated media.": "פלטה בעלת ניגודיות גבוהה עם מדיה דהויה.",
  "Dyslexia": "דיסלקסיה",
  "Friendly font, extra spacing, stronger weight.": "גופן קריא, ריווח נוסף ועובי מודגש.",
  "Low vision": "ירידה בראייה",
  "Dark contrast and 130% magnification.": "ניגודיות כהה והגדלה של ‎130%‎.",
  "Cognitive & Learning": "קוגניטיבי ולמידה",
  "Highlights key sections and enables voice help.": "מדגיש קטעים חשובים ומפעיל עזרה קולית.",
  "Seizure & Epileptic": "התקפים ואפילפסיה",
  "Stops animations and desaturates imagery.": "עוצר אנימציות ומפחית רוויית צבע.",
  "ADHD": "הפרעת קשב (ADHD)",
  "Reading guide, highlighted links, calmer palette.": "מדריך קריאה, קישורים מודגשים ופלטה רגועה יותר.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
